import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../../lib/api";
import { AuthShell } from "./AuthShell";

// ForgotPassword moved to /app/frontend/src/pages/auth/ForgotPassword.jsx

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success("Password updated. Sign in with your new password.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    }
  };
  return (
    <AuthShell title="New password" subtitle="Choose a strong password (min. 8 characters)">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="reset-password-input" type="password" required minLength={8} className="input-dark" placeholder="New password"
          value={password} onChange={(e) => setPassword(e.target.value)} />
        <button data-testid="reset-submit-button" className="btn-primary w-full py-2.5 text-sm font-medium">Update Password</button>
      </form>
    </AuthShell>
  );
}

export function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  useEffect(() => {
    api.get(`/auth/verify-email?token=${params.get("token")}`)
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [params]);
  return (
    <AuthShell title="Email verification" subtitle="">
      {status === "verifying" && <p className="text-sm text-gray-400 animate-pulse">Verifying…</p>}
      {status === "ok" && <p data-testid="verify-success-message" className="text-sm text-[#00E676]">Email verified successfully. You're all set.</p>}
      {status === "error" && <p data-testid="verify-error-message" className="text-sm text-[#FF3B30]">Invalid or expired verification link.</p>}
      <p className="text-sm text-gray-500 text-center mt-6"><Link to="/login" className="text-[#00F0FF] hover:underline">Go to sign in</Link></p>
    </AuthShell>
  );
}
